import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getStickers } from "../../services/mediaService";
import NiceModal from "@ebay/nice-modal-react";
import LoadingIndiactorModal from "../modals/LoadingIndicatorModal";


export type StickersData = {
    stickers: Stickers[];
    StickersUsedThisWeek: Number;
}

export type Stickers = {
    name: string;
    imageUrl: string;
    visibility: boolean;
    id: number;
}


const Stickers = (props: any) => {
    const [stickers, setStickers] = useState<Stickers[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [stickersUsedThisWeek, setStickersUsedThisWeek] = useState<number>(0);
    const handleClose = () => {
        props.toggleStickers();
    };

    useEffect(() => {
        getAndSetStickers();
    }, [])


    const getAndSetStickers = async () => {
        try {
            setIsLoading(true);
            const { data: { stickers, stickersUsedThisWeek } } = await getStickers();
            setStickersUsedThisWeek(stickersUsedThisWeek);
            setStickers(stickers);
        }
        catch (error: any) {
            console.error(error);
        }
        setIsLoading(false);

    };



    const setChosenSticker = (imgUlr: string, stickerId: number) => {
        if (stickersUsedThisWeek > 0) {
            props.setSticker(imgUlr, stickerId);
            props.toggleStickers();
        } else {
            NiceModal.show("action_modal", {
                onNext: () => { NiceModal.hide("action_modal") },
                headerTitle: "לא נשארו עוד מתנות",
                contentTitle: "השתמשת בכל חמש המתנות השבועיות. אין דבר, בשבוע הבא המתנות יתחדשו",
                primaryButtonText: "הבנתי",
                showCloseButton: true,
                showSeconderyButton: false
            });
        }
    }







    return (<>
        {isLoading ? <LoadingIndiactorModal text="" /> :
            <div className="content_sec wf-section">
                <div className="mood_content">
                    <a onClick={handleClose} href="#" className="meet_close gifts w-inline-block">
                        <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
                    </a>
                    <h2 className="signup_title mood">הוספת מתנה</h2>
                    <div className="gifts_info_txt">
                        אפשר לשלוח עד חמש מתנות בשבוע, אז כדאי לשלוח אותן רק למי שמצא חן בעיניך באופן מיוחד
                    </div>
                    <div className="gifts_status_block">
                        <div className="gifts_status_txt">נשארו לך</div>
                        <div className="gifts_status_txt num">{stickersUsedThisWeek}</div>
                        <div className="gifts_status_txt">מתוך</div>
                        <div className="gifts_status_txt num">5</div>
                        <div className="gifts_status_txt">השבוע</div>
                    </div>
                    <ul role="list" className="gifts_list w-list-unstyled">

                        {stickers?.map((sticker, index) => {
                            return (
                                <li key={index} className="gift_item" onClick={() => { setChosenSticker(sticker.imageUrl, sticker.id) }}>
                                    <a href="#" className="gift_link w-inline-block">
                                        <div className="gift_pict_block">
                                            <img
                                                src={sticker.imageUrl}
                                                loading="lazy"
                                                alt=""
                                                className="gift_pict"
                                            />
                                        </div>
                                    </a>
                                </li>
                            )
                        })}

                    </ul>
                    <a onClick={handleClose} href="#" className="clear_link">
                        סגירה
                    </a>
                </div>
            </div>
        }
    </>);
}

export default Stickers;

